import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import styles from "./NavBar.module.css";

export default function NavBar({ logo, links }) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isLogoActive =
    location.pathname === logo.to || (logo.root && location.pathname === logo.root);

  return (
    <nav className={styles.navbar}>
      <div className={styles.left}>
        <Link
          to={logo.to}
          root={logo.root}
          className={`${styles.logo} ${isLogoActive ? styles.active : ""}`}
        >
          <span className={styles.icon}>{logo.icon}</span>
          {logo.label}
        </Link>
      </div>
      <button
        className={`${styles.burger} ${isOpen ? styles.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      <div className={`${styles.links} ${isOpen ? styles.open : ""}`}>
        {links.map(({ path, label, icon }) => (
          <Link
            key={path}
            to={path}
            className={`${styles.link} ${location.pathname === path ? styles.active : ""}`}
          >
            <span className={styles.icon}>{icon}</span>
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
}